import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { value: "" }
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 0,
  class: "form-group"
}
const _hoisted_4 = {
  key: 0,
  class: "dynamic-list"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "flex-row gap-xs" }

import { computed, onMounted, ref, watch } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { ErrorBag } from '@/core/common';
import { CustomerLawFirm, customerLawFirmModeNames, FullCustomer } from '@/modules/customer/Customer';
import { CompanyRecord } from '@/modules/company_record/CompanyRecord';
import { LawFirm, useLawFirm } from '@/modules/law_firm/LawFirm';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppInput from '@/core/components/form/AppInput.vue';
import AppCompanyRecordInput from '@/modules/company_record/components/AppCompanyRecordInput.vue';
import AppCheck from '@/core/components/form/AppCheck.vue';
import AppSelect from '@/core/components/form/AppSelect.vue';
import AppSearchSelect from '@/core/components/form/AppSearchSelect.vue';
import { Option } from '@/core/components/form/Option';
import FaIcon from '@/core/components/FaIcon.vue';
import AppButton from '@/core/components/form/AppButton.vue';

interface CustomerFormBasicsProps {
	customer: FullCustomer;
	errors: ErrorBag;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerFormBasics',
  props: {
    customer: {},
    errors: {}
  },
  emits: [
	'update:customer',
	'lawFirmRemoved',
],
  setup(__props: any, { emit: __emit }) {

const { $gettext } = useGettext();
const lawFirmResource = useLawFirm();
const props = __props;
const emit = __emit;

const data = ref<Partial<FullCustomer>>({});
let lawFirmSearchResults: LawFirm[] = [];
const selectedLawFirmId = ref<string | Option>('');
const showLawFirmSearch = ref<boolean>(false);
const canSelectLawFirm = computed<boolean>(() => data.value.law_firm_mode === 'CUSTOMER' || data.value.law_firm_mode === 'CUSTOMER_FIRST');

onMounted(() => {
	data.value = Object.assign({}, props.customer);
});

watch(() => data.value, (value) => {
	emit('update:customer', value);
}, {
	deep: true,
});

const handleCompanyRecordResult = (record: CompanyRecord) => {
	data.value.name = record.name;
	data.value.phone = record.phone;
	data.value.invoice.address = record.address;
	data.value.invoice.city = record.city;
	data.value.invoice.zipcode = record.zip;
};

const openSearchLawFirm = () => {
	showLawFirmSearch.value = true;
};

const closeSearchLawFirm = () => {
	showLawFirmSearch.value = false;
};

const searchLawFirmCallback = async (query: string): Promise<Option[]> => {
	lawFirmSearchResults = await lawFirmResource.getAllNoPagination({
		name: query,
	});

	return lawFirmSearchResults.map((lawFirm: LawFirm): Option => ({
		value: String(lawFirm.id),
		label: `${lawFirm.name} (${lawFirm.identity_number})`,
	}));
};

const addLawFirm = () => {
	if (!data.value.law_firms || typeof selectedLawFirmId.value !== 'string') {
		return;
	}

	const id = parseInt(selectedLawFirmId.value, 10);
	const lawFirm = lawFirmSearchResults.find(lf => lf.id === id);

	if (!lawFirm) {
		return;
	}

	const customerLawFirm = {
		law_firm: lawFirm,
		can_view_all_tickets: true,
	};

	data.value.law_firms.push(customerLawFirm);

	selectedLawFirmId.value = '';
	closeSearchLawFirm();
};

const removeLawFirm = (customerLawFirm: CustomerLawFirm) => {
	if (!data.value.law_firms) {
		return;
	}

	const index = data.value.law_firms.findIndex((o: CustomerLawFirm) => o.law_firm.id === customerLawFirm.law_firm.id);
	if (index < 0) {
		return;
	}

	emit('lawFirmRemoved', customerLawFirm.law_firm);

	data.value.law_firms.splice(index, 1);
};

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createElementBlock("h2", null, [...(_cache[9] || (_cache[9] = [
      _createTextVNode("Information", -1)
    ]))])), [
      [_directive_translate]
    ]),
    _createVNode(AppFormGroup, {
      id: "customer_identity_number",
      errors: __props.errors.identity_number,
      label: _unref($gettext)('Organisationsnummer')
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(data.value.id ? AppInput : AppCompanyRecordInput), {
          id: "customer_identity_number",
          modelValue: data.value.identity_number,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.value.identity_number) = $event)),
          required: "",
          onCompanyRecordResult: handleCompanyRecordResult
        }, null, 40, ["modelValue"]))
      ]),
      _: 1
    }, 8, ["errors", "label"]),
    _createVNode(AppFormGroup, {
      id: "customer_name",
      errors: __props.errors.name,
      label: _unref($gettext)('Namn')
    }, {
      default: _withCtx(() => [
        _createVNode(AppInput, {
          id: "customer_name",
          modelValue: data.value.name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.name) = $event)),
          required: ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["errors", "label"]),
    _createVNode(AppFormGroup, {
      id: "customer_contact_name",
      errors: __props.errors.contact_name,
      label: _unref($gettext)('Kontaktperson')
    }, {
      default: _withCtx(() => [
        _createVNode(AppInput, {
          id: "customer_contact_name",
          modelValue: data.value.contact_name,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.value.contact_name) = $event)),
          required: ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["errors", "label"]),
    _createVNode(AppFormGroup, {
      id: "customer_email",
      errors: __props.errors.email,
      label: _unref($gettext)('E-postadress')
    }, {
      default: _withCtx(() => [
        _createVNode(AppInput, {
          type: "email",
          id: "customer_email",
          modelValue: data.value.email,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.value.email) = $event)),
          required: ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["errors", "label"]),
    _createVNode(AppFormGroup, {
      id: "customer_phone",
      errors: __props.errors.phone,
      label: _unref($gettext)('Telefonnummer')
    }, {
      default: _withCtx(() => [
        _createVNode(AppInput, {
          type: "tel",
          id: "customer_phone",
          modelValue: data.value.phone,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.value.phone) = $event)),
          required: ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["errors", "label"]),
    _createVNode(AppFormGroup, {
      id: "customer_whistle_phone",
      errors: __props.errors.whistle_phone,
      label: _unref($gettext)('Telefonnummer för visselblåsare')
    }, {
      default: _withCtx(() => [
        _createVNode(AppInput, {
          type: "tel",
          id: "customer_whistle_phone",
          modelValue: data.value.whistle_phone,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((data.value.whistle_phone) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["errors", "label"]),
    _createVNode(AppFormGroup, {
      id: "customer_law_firm_mode",
      errors: __props.errors.law_firm_mode,
      label: _unref($gettext)('Använd extern partner')
    }, {
      default: _withCtx(() => [
        _createVNode(AppSelect, {
          id: "customer_law_firm_mode",
          modelValue: data.value.law_firm_mode,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((data.value.law_firm_mode) = $event)),
          required: ""
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("option", _hoisted_1, [...(_cache[10] || (_cache[10] = [
              _createTextVNode("(Välj)", -1)
            ]))])), [
              [_directive_translate]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_unref(customerLawFirmModeNames)), ([target, targetName]) => {
              return (_openBlock(), _createElementBlock("option", {
                key: target,
                value: target
              }, _toDisplayString(targetName), 9, _hoisted_2))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["errors", "label"]),
    (canSelectLawFirm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (data.value.law_firms.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.law_firms, (customerLawFirm) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: customerLawFirm.law_firm.id
                  }, [
                    _createTextVNode(_toDisplayString(customerLawFirm.law_firm.name) + " ", 1),
                    _createVNode(AppButton, {
                      onClick: _withModifiers(($event: any) => (removeLawFirm(customerLawFirm)), ["prevent"]),
                      class: "t-danger",
                      seamless: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(FaIcon, {
                          weight: "s",
                          icon: "trash-alt"
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(AppFormGroup, {
                      id: `customer_law_firm_${customerLawFirm.law_firm.id}`,
                      label: _unref($gettext)('Kan se samtliga kunds ärenden')
                    }, {
                      before: _withCtx(() => [
                        _createVNode(AppCheck, {
                          id: `customer_law_firm_${customerLawFirm.law_firm.id}`,
                          modelValue: customerLawFirm.can_view_all_tickets,
                          "onUpdate:modelValue": ($event: any) => ((customerLawFirm.can_view_all_tickets) = $event)
                        }, null, 8, ["id", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["id", "label"])
                  ]))
                }), 128))
              ]))
            : _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_5, [...(_cache[11] || (_cache[11] = [
                _createTextVNode(" Ingen extern partner vald ännu. ", -1)
              ]))])), [
                [_directive_translate]
              ]),
          _createElementVNode("a", {
            href: "",
            onClick: _withModifiers(openSearchLawFirm, ["prevent"]),
            class: "button t-success"
          }, [
            _withDirectives((_openBlock(), _createElementBlock("span", null, [...(_cache[12] || (_cache[12] = [
              _createTextVNode("Lägg till", -1)
            ]))])), [
              [_directive_translate]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (canSelectLawFirm.value && showLawFirmSearch.value)
      ? (_openBlock(), _createBlock(AppFormGroup, {
          key: 1,
          id: "customer_law_firm",
          errors: __props.errors.law_firm,
          label: _unref($gettext)('Sök extern partner')
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(AppSearchSelect, {
                id: "customer_law_firm",
                modelValue: selectedLawFirmId.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedLawFirmId).value = $event)),
                "options-cb": searchLawFirmCallback
              }, null, 8, ["modelValue"]),
              _createVNode(AppButton, {
                onClick: _withModifiers(addLawFirm, ["prevent"]),
                class: "t-success",
                title: _unref($gettext)('OK'),
                seamless: "",
                disabled: selectedLawFirmId.value === ''
              }, {
                default: _withCtx(() => [
                  _createVNode(FaIcon, {
                    weight: "s",
                    icon: "check"
                  })
                ]),
                _: 1
              }, 8, ["title", "disabled"]),
              _createVNode(AppButton, {
                onClick: _withModifiers(closeSearchLawFirm, ["prevent"]),
                class: "t-danger",
                title: _unref($gettext)('Avbryt'),
                seamless: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(FaIcon, {
                    weight: "s",
                    icon: "times"
                  })
                ]),
                _: 1
              }, 8, ["title"])
            ])
          ]),
          _: 1
        }, 8, ["errors", "label"]))
      : _createCommentVNode("", true),
    _createVNode(AppFormGroup, {
      id: "customer_demo",
      errors: __props.errors.demo,
      label: _unref($gettext)('Är demokund')
    }, {
      before: _withCtx(() => [
        _createVNode(AppCheck, {
          id: "customer_demo",
          modelValue: data.value.demo,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((data.value.demo) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["errors", "label"])
  ]))
}
}

})